// extracted by mini-css-extract-plugin
export default {"counter-offer-modal":"styles__counter-offer-modal--A32c+","modal-title":"styles__modal-title--677Ba","counter-offer-modal-mobile":"styles__counter-offer-modal-mobile--kBi6E"};